import {atom} from "recoil";
import keys from "configs/atoms";

const lookupAffiliateProgramsAtom = atom(({
    key: keys.Lookup.AffiliatePrograms,
    default: []
}));

export default lookupAffiliateProgramsAtom;